import React from 'react';
import tagColors from '../constants/tagColors';
import { Link } from 'gatsby';

export function Tag({ label, slug }) {
  const tagColor = tagColors[slug] || 'black';
  return (
    <Link
      to={`/blog/c/${slug}/1/`}
      className="inline-flex  bg-black/[.03] rounded-lg px-2 p-1 w-fit text-[11px] leading-tight uppercase"
      style={{ color: tagColor }}
    >
      {label}
    </Link>
  );
}
